import Login from "../../screens/auth/Login";
import DesignationCE from "../../screens/options/designation/DesignationCE";
import DepartmentCE from "../../screens/options/department/DepartmentCE";
import DepartmentList from "../../screens/options/department/DepartmentList";
import DesignationList from "../../screens/options/designation/DesignationList";
import RoleList from "../../screens/options/roles/RoleList";
import RoleCE from "../../screens/options/roles/RoleCE";
import Settings from "../../screens/staticscreens/Settings";
import Support from "../../screens/staticscreens/Support";
import Profile from "../../screens/profile/Profile";

// import OnboardList from "../../screens/onboard/OnboardList";
// import Onboard from "../../screens/onboard/Onboard";
import PrivacyPolicy from "../../screens/staticscreens/PrivacyPolicy";
import Mainprofile from "../../screens/profile/Mainprofile";
import UpdatePassword from "../../screens/auth/UpdatePassword";
import Account from "../../screens/profile/Account";
import ThemeUser from "../../screens/profile/ThemeUser";
import UserNotification from "../../screens/profile/UserNotification";
import UserOrganization from "../../screens/profile/UserOrganization";
import Accessability from "../../screens/profile/Accessablity";


import OnboardList from "../../screens/onboard/OnboardList";
import Onboard from "../../screens/onboard/Onboard";
import DashboardMenu from "../../screens/dashboard/DashboardMenu";
import Dashboard from "../../screens/dashboard/Dashboard";
import CallsMenu from "../../screens/calls/CallsMenu";
import CallsList from "../../screens/calls/CallsList";
import CallsListCE from "../../screens/calls/CallsListCE";
import DeleteData from "../../screens/staticscreens/DeleteData";
import UploadExcelData from "../../screens/staticscreens/UploadExcelData";
import UserAttendances from "../../screens/staticscreens/UserAttendances";
import CaseTypeList from "../../screens/options/casetype/CaseTypeList";
import CaseTypeCE from "../../screens/options/casetype/CaseTypeCE";
import CaseStageList from "../../screens/options/casestage/CaseStageList";
import CaseStageCE from "../../screens/options/casestage/CaseStageCE";
import ClientMenu from "../../screens/client/ClientMenu";
import ClientList from "../../screens/client/ClientList";
import ClientCE from "../../screens/client/ClientCE";
import CaseMenu from "../../screens/case/CaseMenu";
import CaseList from "../../screens/case/CaseList";
import CaseCE from "../../screens/case/CaseCE";
import OpinionMenu from "../../screens/opinion_files/OpinionMenu";
import OpinionList from "../../screens/opinion_files/OpinionList";
import OpinionCE from "../../screens/opinion_files/OpinionCE";
import OpinionDetail from "../../screens/opinion_files/OpinionDetail";
import BillsMenu from "../../screens/bills/BillsMenu";
import BillsList from "../../screens/bills/BillsList";
import CaseDetail from "../../screens/case/CaseDetail";
import AdminCaseList from "../../screens/dashboard/AdminCaseList";
import TodayWork from "../../screens/today_work/TodayWork";
import TodayCaseMenu from "../../screens/today_work/TodayCaseMenu";
import DriveMenu from "../../screens/drive/DriveMenu";
import DriveHome from "../../screens/drive/DriveList";
import TrashList from "../../screens/drive/TrashList";
import StarList from "../../screens/drive/StarList";
import RecentActivityList from "../../screens/drive/RecentActivityList";
import EditDriveFile from "../../screens/drive/EditDriveFile";
import EditPDFDriveFile from "../../screens/drive/EditPDFDriveFile";
import DriveLink from "../../screens/drive/DriveLink";
import BillCaseCE from "../../screens/bills/CaseCE";
import DriveCredentialsCE from "../../screens/options/DriveCredentialsCE";

// import DashboardMenu from "../../screens/dashboard/DashboardMenu";

export const routes = [
    {
        path:"/",
        component:<Login/>,
        private:false,
        roles:[]
    },
    {
        path:"/settings",
        component:<Settings/>,
        private:true,
        roles:['controller','admin']
    },
   
    {
        path:"/settings/department",
        component:<DepartmentList/>,
        private:true,
        roles:['controller','admin']
    },
   
    {
        path:"/dashboard",
        component:<DashboardMenu/>,
        private:true,
        roles:[]
    },
    {
        path:"/dashboard/my_dashboard",
        component:<Dashboard/>,
        private:true,
        roles:[]
    },
    {
        path:"/dashboard/case_list",
        component:<AdminCaseList/>,
        private:true,
        roles:[]
    },
    {
        path:"/calls",
        component:<CallsMenu/>,
        private:true,
        roles:[]
    },
    {
        path:"/calls/list",
        component:<CallsList/>,
        private:true,
        roles:[]
    },
    {
        path:"/calls/list/:type",
        component:<CallsListCE/>,
        private:true,
        roles:[]
    },
   
   
    {
        path:"/settings/department/create",
        component:<DepartmentCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/department/edit",
        component:<DepartmentCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/designation",
        component:<DesignationList/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/designation/create",
        component:<DesignationCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/designation/edit",
        component:<DesignationCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/roles",
        component:<RoleList/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/roles/create",
        component:<RoleCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/roles/edit",
        component:<RoleCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/case_type",
        component:<CaseTypeList/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/case_type/:type",
        component:<CaseTypeCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/case_stage",
        component:<CaseStageList/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/case_stage/:type",
        component:<CaseStageCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings",
        component:<Settings/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/onboard_list",
        component:<OnboardList/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/onboard_list/create",
        component:<Onboard/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/onboard_list/edit",
        component:<Onboard/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/mass_delete",
        component:<DeleteData/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/upload_data",
        component:<UploadExcelData/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/settings/user_attendance",
        component:<UserAttendances/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/opinion_files",
        component:<OpinionMenu/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/opinion_files/:type",
        component:<OpinionList/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/opinion_files/:type/detail",
        component:<OpinionDetail/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/opinion_files/:type/:type",
        component:<OpinionCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/client",
        component:<ClientMenu/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/client/:type",
        component:<ClientList/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/client/:type/:type",
        component:<ClientCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/case",
        component:<CaseMenu/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/case/:type",
        component:<CaseList/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/case/:type/detail",
        component:<CaseDetail />,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/case/:type/:type",
        component:<CaseCE/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/support",
        component:<Support/>,
        private:true,
        roles:[]
    },
    {
        path:"/profile",
        component:<Mainprofile/>,
        private:true,
        roles:[]
    },
    {
        path:"/privacy",
        component:<PrivacyPolicy/>,
        private:false,
        roles:[]

    },
    {
        path:"/profile",
        component:<Profile/>,
        private:true,
        roles:[]
    },
    {
        path:"/profile/basic",
        component:<Mainprofile/>,
        private:true,
        roles:[]
    },
    {
        path:"/profile/update_password",
        component:<UpdatePassword/>,
        private:true,
        roles:[]
    },
    {
        path:"/profile/account",
        component:<Account/>,
        private:true,
        roles:['controller','admin']
    },
    {
        path:"/profile/appearance",
        component:<ThemeUser/>,
        private:true,
        roles:[]
    },
    {
        path:"/profile/notifications",
        component:<UserNotification/>,
        private:true,
        roles:[]
    },
    {
        path:"/profile/organiztion",
        component:<UserOrganization/>,
        private:true,
        roles:[]
    },
    {
        path:"/profile/accessibility",
        component:<Accessability/>,
        private:true,
        roles:[]
    },
    {
        path:"/bills",
        component:<BillsMenu/>,
        private:true,
        roles:[]
    },
    {
        path:"/bills/:type",
        component:<BillsList/>,
        private:true,
        roles:[]
    },
    {
        path:"/bills/create",
        component:<BillCaseCE/>,
        private:true,
        roles:[]
    },
    {
        path:"/today_work",
        component:<TodayCaseMenu/>,
        private:true,
        roles:[]
    },
    {
        path:"/today_work/list",
        component:<TodayWork/>,
        private:true,
        roles:[]
    },
    {
        path:"/drive",
        component:<DriveMenu/>,
        private:true,
        roles:[]
    },
    {
        path:"/drive/home",
        component:<DriveHome/>,
        private:true,
        roles:[]
    },
    {
        path:"/drive/trash",
        component:<TrashList/>,
        private:true,
        roles:[]
    },
    {
        path:"/drive/starred",
        component:<StarList/>,
        private:true,
        roles:[]
    },
    {
        path:"/drive/recent_activity",
        component:<RecentActivityList/>,
        private:true,
        roles:[]
    },
    {
        path:"/drive/edit_drive",
        component:<EditDriveFile/>,
        private:true,
        roles:[]
    },
    {
        path:"/drive/pdf_file_edit_drive",
        component:<EditDriveFile/>,
        private:true,
        roles:[]
    },
    {
        path:"/drive/drive_link",
        component:<DriveLink/>,
        private:true,
        roles:[]
    },
    {
        path:"/settings/drive_credentials",
        component:<DriveCredentialsCE/>,
        private:true,
        roles:[]
    }
]